import { styled } from "@mui/material/styles";

const PREFIX = "GenericProGrid";

export const classes = {
    headerBox: `${PREFIX}-headerBox`,
    headerGrid: `${PREFIX}-headerGrid`,
    expandIcon: `${PREFIX}-expandIcon`,
    expandButton: `${PREFIX}-expandButton`,
    filterField: `${PREFIX}-filterField`,
    gridCellCentered: `${PREFIX}-gridCellCentered`,
};

export const Root = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    height: "100%",

    [`& .${classes.headerBox}`]: {
        display: "flex",
        alignItems: "center",
        "& > :not(style)": { margin: "0px 8px 10px 8px" },
        width: "100%",
    },

    [`& .${classes.headerGrid}`]: {
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "nowrap",
        marginLeft: "0px !important",
        marginRight: "0px !important",
        "@media(max-width: 899px)": {
            flexDirection: "column",
            gap: "8px",
        },
    },

    [`& .${classes.expandIcon}`]: {
        transform: "rotate(90deg)",
    },

    [`& .${classes.expandButton}`]: {
        height: "32px",
        minWidth: "35px !important",
        padding: "0 0 !important",
        "& svg": { color: theme.palette.mediumDarkGrey?.main },
        "&:hover": { "& svg": { color: theme.palette.cobaltBlue?.main } },
    },

    [`& .${classes.filterField}`]: {
        marginTop: "0px",
    },

    [`& .${classes.gridCellCentered}`]: {
        textAlign: "center",
    },
}));
